import React, { useState, useEffect } from "react";
import {
  Input,
  Space,
  Card,
  Spin,
  Button,
  Radio,
  message,
  Result,
  Typography,
} from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import NotFoundMessage from "./NotFoundMessage";
import "./StudentDetails.css";
import Siblings from "./Siblings";
import Print from "./Print"; // Import the Print component
import dayjs from "dayjs";
const { Search } = Input;
const { Paragraph, Text } = Typography;

const StudentDetails = () => {
  const [studentData, setStudentData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [searchedRollNo, setSearchedRollNo] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [abhaNumber, setAbhaNumber] = useState("");
  const [showPrint, setShowPrint] = useState(false); // State to control Print component visibility
  const [siblingData, setSiblingData] = useState([]); // Store sibling data
  const [responseMessage, setResponseMessage] = useState("");
  const [showSuccess, setShowSuccess] = useState(false); // State to show success modal
  const [showError, setShowError] = useState(false); // State to show error modal
  const handleOk = () => {
    window.location.reload(); // Refresh the page
  };
  // Sibling data handler
  const handleSiblingDataChange = (data) => {
    setSiblingData(data.siblings); // Ensure this is correctly updating the state
  };
  // const siblingDOB =
  //   siblingData && siblingData.length > 0 ? siblingData[0].siblingDOB : null;
  // const formattedDate = siblingDOB
  //   ? dayjs(siblingDOB).format("DD-MM-YYYY")
  //   : "No Date Available";

  useEffect(() => {
    const savedOption = localStorage.getItem("selectedOption");
    if (savedOption) {
      setSelectedOption(savedOption);
    }
  }, []);
  const handleAbhaNumberChange = (e) => {
    const value = e.target.value;
    // Allow only numbers and limit to 14 characters
    if (/^\d*$/.test(value) && value.length <= 14) {
      setAbhaNumber(value);
    }
  };

  const mapSexValue = (sex) => {
    if (sex === "Male") return "MALE";
    if (sex === "FEMALE") return "FEMALE";
    return "OTHERS";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const parts = dateString.split("-");
    if (parts.length === 3) {
      const [day, month, year] = parts;
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    }
    return dateString;
  };

  const getApiUrl = (rollNo) => {
    let baseUrl = "https://laudea.psgitech.ac.in/sis/public/student/details";
    let baseUrl1 = "https://laudea.psgcas.ac.in/sisv2/public/student/details";
    let baseUrl2 = "https://laudea.psgim.ac.in/sis/public/student/details";
    let headers = {
      "Content-Type": "application/json",
      authorization: "jQCHBwDboSyOM8OTWsKLvX9qGRBzvAzr", // Add your token here
    };
    let headers1 = {
      "Content-Type": "application/json",
      authorization: "pF7DEN8W9grPVg6NOUGUITlT6orVZSKu", // Add your token here
    };
    let headers2 = {
      "Content-Type": "application/json",
      authorization: "UAMd7J0kKFCoGZqulshMGTCqbCj4AowG", // Add your token here
    };
    // const baseUrl =
    //   "https://hsissmart.psghospitals.com/ps4/api/studentop/registation";
    let url = `${baseUrl}/${rollNo}`;

    if (selectedOption === "option1") {
      return { url, headers };
    } else if (selectedOption === "option2") {
      url = `${baseUrl1}/${rollNo}`;
      headers = headers1;
      return { url, headers };
    } else if (selectedOption === "option3") {
      url = `${baseUrl2}/${rollNo}`;
      headers = headers2;
      return { url, headers };
    }

    return { url, headers };
  };

  const onSearch = async (value) => {
    const upperCaseValue = value.toUpperCase();
    if (upperCaseValue.trim() === "") {
      setStudentData(null);
      setError("Please enter a roll number.");
      return;
    }
    if (!selectedOption) {
      message.error("Please choose a department.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const { url, headers } = getApiUrl(upperCaseValue);

      const response = await axios.get(url, { headers });

      if (
        response.data &&
        Object.keys(response.data).length > 0 &&
        response.data !== "Student Not Found."
      ) {
        setStudentData(response.data);
        setSearchedRollNo(upperCaseValue);
        setError(null);
      } else {
        setStudentData(null);
        setError("Student not found");
      }
    } catch (err) {
      setError("An error occurred while fetching data.");
    }

    setSearchValue("");
    setLoading(false);
  };

  const handleChange = (e) => {
    const value = e.target.value.toUpperCase();
    setSearchValue(value);
  };

  const onRadioChange = (e) => {
    const value = e.target.value;
    setSelectedOption(value);
    localStorage.setItem("selectedOption", value);
  };

  const onSubmit = async () => {
    if (!studentData) {
      message.error("No student data to submit.");
      return;
    }

    try {
      setLoading(true);
      const payload = {
        dummyRollNo: studentData.DRollNo || "",
        Name: studentData.Name || "",
        Sex: studentData.Sex || "",
        DOB: formatDate(studentData.DOB) || "",
        Batch: studentData.Batch || "",
        ProgName: studentData.ProgName || "",
        SemNo: studentData.SemNo || "",
        DateOfJoin: formatDate(studentData.DateOfJoin) || "",
        CommName: studentData.CommName || "",
        StudStatus: studentData.StudStatus || "",
        NationalityName: studentData.NationalityName || "",
        ReligionName: studentData.ReligionName || "",
        BloodGroup: studentData.BloodGroup || "",
        AddrName: studentData.AddrName || "", // Ensure that AddrName exists in studentData
        Address1: studentData.Address1 || "",
        Address2: studentData.Address2 || "",
        Address3: studentData.Address3 || "",
        Pincode: studentData.Pincode || "",
        StateName: studentData.StateName || "",
        FatherMobile: studentData.FatherMobile || "",
        Email: studentData.Email || "",
        StudMobile: studentData.StudMobile || "",
        FatherName: studentData.FatherName || "",
        FatherOccupation: studentData.FatherOccupation || "",
        AadharNo: studentData.AadharNo || "",
        Handicap_Tag: studentData.Handicap_Tag || "",
        Abhaid: abhaNumber || "",
        RollNo: studentData.RollNo || "",
        NativePlace: studentData.NativePlace || "",
        Siblings: siblingData.map((sibling) => ({
          SiblingName: sibling.siblingName || "",
          SiblingSex: sibling.siblingSex || "",
          SiblingDOB: sibling.siblingDOB
            ? dayjs(sibling.siblingDOB).format("DD-MM-YYYY")
            : "No Date Available",
          SiblingRelation: sibling.siblingRelation || "",
          siblingAbhaid: sibling.siblingAbhaid || "",
          // siblingApplno: sibling.siblingApplno || "",
          // siblingAadharno: sibling.siblingAadharno || "",
          // siblingEmail: sibling.siblingEmail || "",
          // siblingMobileNo: sibling.siblingMobileNo || "",
        })),
      };

      const response = await axios.post(
        "https://hsissmart.psghospitals.com/ps3/api/studentop/registation/live",
        payload
      );
      console.log(response.data);
      if (response.data && response.data.status) {
        // Extract OP_CODE from response and set it in responseMessage
        const opCode = response.data.opcode.OP_CODE; // Make sure this is the correct path in the response
        const billcode = response.data.opcode.BILL_CODE; // Make sure this is the correct path in the response

        //const billCode = response.data.billCode.BIL; // Make sure this is the correct path in the response
        setResponseMessage(
          `Success! OP_CODE: ${opCode}, DROLLNO: ${response.data.opcode.DROLLNO}, BILL_CODE: ${billcode}`
        );
        setShowSuccess(true);

        // Pass the opCode to the Print component by setting it in state
        setShowPrint(true); // Show Print component after successful submission
      } else {
        setResponseMessage("Failed to submit data.");
      }
    } catch (error) {
      setResponseMessage("Error submitting data.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="search-container">
      <h1 className="main-heading">
        PSG Hospitals Students Fitness Registration
      </h1>
      <Space direction="vertical" className="search-bar">
        <Search
          value={searchValue}
          onChange={handleChange}
          placeholder="Enter the Roll No"
          allowClear
          enterButton="Search"
          size="large"
          onSearch={onSearch}
        />
      </Space>
      <div className="radio-group">
        <Radio.Group onChange={onRadioChange} value={selectedOption}>
          <Radio value="option1">PSGITECH</Radio>
          <Radio value="option2">PSGCAS</Radio>
          <Radio value="option3">PSGIM</Radio>
        </Radio.Group>
      </div>
      <div className="card-container">
        {loading ? (
          <Spin className="spinner" />
        ) : error ? (
          <NotFoundMessage />
        ) : studentData ? (
          <Card
            title={`Student Details for Roll No: ${searchedRollNo}`}
            bordered={false}
          >
            <div className="card-content">
              <p>
                <strong>Name:</strong> {studentData.Name}
              </p>
              <p>
                <strong>Sex:</strong> {studentData.Sex}
              </p>
              <p>
                <strong>Date of Birth:</strong> {formatDate(studentData.DOB)}
              </p>
              <p>
                <strong>Batch:</strong> {studentData.Batch}
              </p>
              <p>
                <strong>Program:</strong> {studentData.ProgName}
              </p>
              <p>
                <strong>Semester:</strong> {studentData.SemNo}
              </p>
              <p>
                <strong>Date of Joining:</strong>{" "}
                {formatDate(studentData.DateOfJoin)}
              </p>
              <p>
                <strong>Community:</strong> {studentData.CommName}
              </p>
              <p>
                <strong>Status:</strong> {studentData.StudStatus}
              </p>
              <p>
                <strong>Nationality:</strong> {studentData.NationalityName}
              </p>
              <p>
                <strong>Religion:</strong> {studentData.ReligionName}
              </p>
              <p>
                <strong>Blood Group:</strong> {studentData.BloodGroup}
              </p>
              <p>
                <strong>Address:</strong>{" "}
                {`${studentData.Address1}, ${studentData.Address2}, ${studentData.Address3}, ${studentData.Pincode}, ${studentData.StateName}`}
              </p>
              <p>
                <strong>Father's Mobile:</strong> {studentData.FatherMobile}
              </p>
              <p>
                <strong>Email:</strong> {studentData.Email}
              </p>
              <p>
                <strong>Student's Mobile:</strong> {studentData.StudMobile}
              </p>
              <p>
                <strong>Father's Name:</strong> {studentData.FatherName}
              </p>
              <p>
                <strong>Father's Occupation:</strong>{" "}
                {studentData.FatherOccupation}
              </p>
              <p>
                <strong>Aadhar Number:</strong> {studentData.AadharNo}
              </p>
              <p>
                <strong>Handicap Tag:</strong> {studentData.Handicap_Tag}
              </p>
            </div>
            <div className="abha-section">
              <label htmlFor="abhaNumber" className="abha-label">
                ABHA NO
              </label>
              <Input
                id="abhaNumber"
                value={abhaNumber}
                onChange={handleAbhaNumberChange}
                size="large"
                placeholder="Enter ABHA Number"
                style={{ width: "100%" }}
              />
            </div>
            <Siblings onSiblingDataChange={handleSiblingDataChange} />
            <Button type="primary" onClick={onSubmit} className="submit-button">
              Submit
            </Button>
          </Card>
        ) : null}
      </div>
      {showSuccess && (
        <Result
          status="success"
          title="Submission Successful!"
          extra={[
            <Button type="primary" onClick={handleOk}>
              Ok
            </Button>,
          ]}
        />
      )}

      {showError && (
        <Result
          status="error"
          title="Submission Failed"
          subTitle="Data Already Found for this Roll No"
          extra={[
            <Button type="primary" onClick={handleOk}>
              Ok
            </Button>,
          ]}
        ></Result>
      )}

      {showPrint && (
        <Print
          name={studentData?.Name}
          opNumber={responseMessage?.match(/OP_CODE: (\w+)/)?.[1]}
          billCode={responseMessage?.match(/BILL_CODE: (\w+)/)?.[1]} // Extract BILL_CODE using regex
        />
      )}
    </div>
  );
};

export default StudentDetails;
